import { render, staticRenderFns } from "./Parnters.vue?vue&type=template&id=0723b9e2&scoped=true&"
import script from "./Parnters.vue?vue&type=script&lang=ts&"
export * from "./Parnters.vue?vue&type=script&lang=ts&"
import style0 from "./Parnters.vue?vue&type=style&index=0&id=0723b9e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723b9e2",
  null
  
)

export default component.exports